/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetConsigneeDeliveryNoteBundlesCheckinResponse } from '../../models/get-consignee-delivery-note-bundles-checkin-response';
import { KeyType } from '../../models/key-type';
import { Token64LengthType } from '../../models/token-64-length-type';

export interface GetConsigneeBundlesForCheckin$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
  token: Token64LengthType;
}

export function getConsigneeBundlesForCheckin(http: HttpClient, rootUrl: string, params: GetConsigneeBundlesForCheckin$Params, context?: HttpContext): Observable<StrictHttpResponse<GetConsigneeDeliveryNoteBundlesCheckinResponse>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeBundlesForCheckin.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetConsigneeDeliveryNoteBundlesCheckinResponse>;
    })
  );
}

getConsigneeBundlesForCheckin.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-note-bundles/checkin';
